export type SignTypeSource = 'web' | 'onecvk' | 'public';

export enum SignTypeSources {
  web = 'Веб-интерфейс',
  onecvk = '1С',
  public = 'API',
}
